import {Component, Inject, OnInit} from '@angular/core';
import {ISimpleSelectableDataList} from "../../model/interface/simple-selectable-data.model.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-simple-select-dialog',
  templateUrl: './simple-select-dialog.component.html',
  styleUrls: ['./simple-select-dialog.component.css']
})
export class SimpleSelectDialogComponent implements OnInit {
  title: string;
  label: string;
  data: ISimpleSelectableDataList;

  constructor(private dialogRef: MatDialogRef<SimpleSelectDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.label = data.label;
    this.data = data.data;
  }

  ngOnInit(): void {
  }

  select($event: any) {
    this.dialogRef.close($event);
  }
}
